import React from 'react';
import PropTypes from 'constants/PropTypes';
import { Field } from 'redux-form';
import SimpleFieldComponent from './SimpleFieldComponent';
import commonPropTypes from './commonPropTypes';

const SimpleField = (props) => <Field component={SimpleFieldComponent} {...props} />;

SimpleField.propTypes = {
    name: PropTypes.string.isRequired,
    ...commonPropTypes,
};

export default SimpleField;
